import { i18n } from 'lib/i18n.js';
import ClickOutside from 'vue-click-outside';
import { mapState, mapActions } from 'vuex';

export default {
  i18n,
  directives: {
    ClickOutside,
  },
  props: ['name', 'options', 'isGroups'],
  data: () => {
    return {
      selectedIndex: 0,
      open: false,
      filterApplied: false,
    };
  },
  computed: {
    ...mapState('vto', ['activeGroup']),
    selected() {
      if (!this.isGroups && !this.filterApplied) {
        return `${this.name}`;
      }
      return `${this.options[this.selectedIndex]} ${this.name}`;
    },
  },
  methods: {
    ...mapActions('vto', [
      'setActiveGroup',
      'addActiveFilter',
      'replaceActiveFilter',
    ]),
    handleOptionChange(name, option) {
      this.filterApplied = true;
      this.selectedIndex = this.options.indexOf(option);

      this.isGroups
        ? this.setActiveGroup(option)
        : this.setSelectedFilters(option, name);
      this.toggleDropdown();
    },
    setSelectedFilters(value, name) {
      this.addActiveFilter({ key: name, value });
    },
    toggleDropdown() {
      this.open = !this.open;
    },
    close() {
      this.open = false;
    },
  },
  template: `
    <fieldset
      class="vto-filter-group"
      v-click-outside="close"
      @click="toggleDropdown"
    >
      <div
        class="vto-filter-group__header"
        :class="{ 'vto-filter-group__header--hidden': open }"
      >
        <h3
          class="vto-filter-group__selected"
          v-html="selected"
        >
        </h3>
        <span class="vto-filter-group__chevron">
          <svg width="12" height="7" viewBox="0 0 12 7" xmlns="http://www.w3.org/2000/svg">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-expand"></use>
          </svg>
        </span>
      </div>
      <legend class="vto-filter-group__legend" v-html="name"></legend>
      <div
        class="vto-filter-group__options"
        :class="{ 'vto-filter-group__options--visible': open }"
      >
        <div
          class="vto-filter-group__option-wrapper"
          v-for="(option, index) in options"
        >
          <input
            class="vto-filter-group__radio"
            type="radio"
            :id="option"
            :name="name"
            :value="option"
            @change="handleOptionChange(name, option)"
            :checked="isGroups && option === activeGroup"
          />
          <label
            class="vto-filter-group__label"
            :for="option"
            v-html="option"
          >
          </label>
        </div>
      </div>
    </fieldset>
  `,
};
